import React, { useEffect, useState } from "react";
import barLoading from "../../assets/images/barLoading.svg";
import { classNames } from "../../helpers/classNames";

const compressImageHandler = (file, quality = 1) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, img.width, img.height);

        canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          "image/jpeg",
          quality // 0.1 (low) to 1.0 (high)
        );
      };
    };
  });
};

const CompressImage = ({
  src,
  alt,
  className,
  quality = 0.8,
  loadingClass,
  props,
}) => {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAndCompressImage = async () => {
      if (!src) return;

      try {
        setLoading(true);
        // Fetch image as Blob
        const response = await fetch(src);
        const blob = await response.blob();

        // Compress the image
        const compressedBlob = await compressImageHandler(blob, quality);

        // Create URL for preview
        const compressedUrl = URL.createObjectURL(compressedBlob);
        setImage(compressedUrl);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching or compressing image:", error);
      }
    };

    fetchAndCompressImage();
  }, [src]);
  return image ? (
    <img src={image} alt={alt} className={className} {...props} />
  ) : (
    <div className="w-full h-full bg-slate-50 flex items-center justify-center">
      {loading && (
        <img
          src={barLoading}
          alt="loading"
          className={classNames("w-1/4 h-1/4", loadingClass)}
        />
      )}
    </div>
  );
};

export default CompressImage;
